import LazyRoute from 'approot/shared/routes/lazy-route';
import {
  PRIVATE_CLASSES_PARAM,
  PRIVATE_MARKBOOK,
  PRIVATE_MARKBOOK_UNITS,
  PRIVATE_MARKBOOK_ASSESSMENT,
} from 'global/private-routes.constants';
import { RouteConfig } from 'lib/router/router.constants';

import MarkbookFlagGuard from './logic/markbook-flag-guard';

// `MarkbookFlagGuard` rather than `LazyRoute`'s feature-flag argument, which
// renders Not Found — marking emails link here, and are sent to teachers the
// flag may not be on for yet.
const markbookRoute = (importFn: () => Promise<any>) => {
  const Route = LazyRoute(importFn, true);
  return (props: any) => (
    <MarkbookFlagGuard>
      <Route {...props} />
    </MarkbookFlagGuard>
  );
};

const markbookRoutes: RouteConfig[] = [
  {
    path: [`${PRIVATE_CLASSES_PARAM}${PRIVATE_MARKBOOK}`, PRIVATE_MARKBOOK],
    component: markbookRoute(() => import('./reports/subject-report')),
  },
  {
    path: [
      `${PRIVATE_CLASSES_PARAM}${PRIVATE_MARKBOOK_UNITS}`,
      PRIVATE_MARKBOOK_UNITS,
    ],
    component: markbookRoute(() => import('./reports/unit-report')),
  },
  // Remounted under /markbook so drilling in keeps the nav item and breadcrumbs.
  {
    path: [
      `${PRIVATE_CLASSES_PARAM}${PRIVATE_MARKBOOK_ASSESSMENT}`,
      PRIVATE_MARKBOOK_ASSESSMENT,
    ],
    component: markbookRoute(() => import('./reports/assessment-report')),
  },
];

export default markbookRoutes;
